import { SnackInfoCard } from './SnackCard.styles';
import { SnackCardSkeleton } from './SnackCardSkeleton';

export type Props = {
  isLoading: boolean;
  mobileScreen: boolean;
  css?: any;
};
export const SnackCardLoader = ({ isLoading, mobileScreen, css }: Props) => (
  <SnackInfoCard
    alignContent="center"
    alignItems="center"
    css={css}
    direction="column"
    isLoading={isLoading}
    justify="space-between"
  >
    <SnackCardSkeleton mobileScreen={mobileScreen} />
  </SnackInfoCard>
);
